import React, { useState } from "react";
import { connect } from "react-redux";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Button } from "@mui/material";
import { toast } from "react-toastify";
import { getIvrTripKey } from "../../actions/ivrTripStorage";
import {
  ivrRequest,
  TIMEOUT_MESSAGE,
  AXIOS_ERROR,
} from "../../constants/default_request";
import { mapIvrStateToProps } from "../../services/mapStateToProps";
import { BaseAPI } from "../../apis/BaseAPI";

const IvrSavedTrips = ({ auth, vesselNbr, status = false, trip }) => {
  const [open, setOpen] = useState(status);
  const { payload = {}, url = "", type = "" } = trip;
  const localStorageKey = getIvrTripKey(auth.client_id);

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = () => {
    localStorage.removeItem(localStorageKey);
    setOpen(false);
  };

  const handleSubmit = () => {
    const request_data = ivrRequest(
      auth.client_id,
      auth.token,
      auth.user_app_status,
      vesselNbr
    );
    const newPayload = {
      ...payload,
      ...request_data,
    };

    BaseAPI.call(url, newPayload)
      .then((response) => {
        if (response.data.hasOwnProperty("errors")) {
          toast.error(`An error occurred.  ${response.data.errors}`, {
            autoClose: false,
          });
        } else {
          localStorage.removeItem(localStorageKey);
        }

        toast.success(`Submission status: ${response.data.status}`);
        console.log("API Response", response.data, response.data.status);
      })
      .catch((error) => {
        if (error.hasOwnProperty("name") && error.name === AXIOS_ERROR) {
          toast.error(TIMEOUT_MESSAGE, { autoClose: false });
        } else {
          toast.error(`An error occurred.  ${error.message}`, {
            autoClose: false,
          });
        }
      });
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="ivr-saved-trip"
      aria-describedby="ivr-saved-trip-description"
    >
      <DialogTitle id="ivr-saved-trip">Existing IVR Data</DialogTitle>
      <DialogContent>
        <DialogContentText id="ivr-saved-trip-description">
          There is an unsubmitted "{type.replaceAll("_", " ").toUpperCase()}"
          data saved locally. Do you want to submit it or delete the existing
          information?
        </DialogContentText>
        <DialogActions>
          <Button onClick={handleDelete} color="primary">
            Delete
          </Button>
          <Button onClick={handleSubmit} color="primary" autoFocus>
            Submit
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default connect(mapIvrStateToProps)(IvrSavedTrips);
